export const CONTENT_DELETE_WARNING_MODAL = 'CONTENT_DELETE_WARNING_MODAL';
export const FULL_WIDTH_EXIT_MODAL = 'FULL_WIDTH_EXIT_MODAL';
export const AI_DYNAMIC_TOKEN_MODAL = 'AI_DYNAMIC_TOKEN_MODAL';